export enum AssignPriceOptionType {
	"DEFAULT_PRICE" = "DEFAULT_PRICE",
	"PRICE_BASED_ON_PRICE_LISTS" = "PRICE_BASED_ON_PRICE_LISTS",
	"SET_PRICE" = "SET_PRICE",
	"RESET" = "RESET",
	"CHANGE_DEFAULT_PRICE_BY_VALUE" = "CHANGE_DEFAULT_PRICE_BY_VALUE",
	"CHANGE_PRICE_LIST_PRICE_BY_VALUE" = "CHANGE_PRICE_LIST_PRICE_BY_VALUE",
}

export enum ChangePriceByValueType {
	INCREASE = "INCREASE",
	DECREASE = "DECREASE",
}
